import { Component } from '@angular/core';

@Component({
  selector: 'r2e-vertical-logo',
  templateUrl: './vertical-logo.component.svg',
  styleUrl: './logo.component.scss'
})
export class VerticalLogoComponent {}
